var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 1.73523V18.2648C19.9994 18.7248 19.8164 19.1658 19.4911 19.4911C19.1658 19.8164 18.7248 19.9994 18.2648 20H1.73523C1.2752 19.9994 0.834189 19.8164 0.508901 19.4911C0.183613 19.1658 0.000601342 18.7248 0 18.2648V1.73523C0.000601342 1.2752 0.183613 0.834189 0.508901 0.508901C0.834189 0.183613 1.2752 0.000601342 1.73523 0H18.2648C18.7248 0.000601342 19.1658 0.183613 19.4911 0.508901C19.8164 0.834189 19.9994 1.2752 20 1.73523Z",
    fill: "#C06674"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStop);
export default __webpack_public_path__ + "static/media/icon_stop.05766f2716705861f08d15106699a41f.svg";
export { ForwardRef as ReactComponent };